module.exports = __webpack_public_path__ + "static/Carly_Daniel1-db5fe9e01871e7900e2238c22cf905ab.jpg";